const m = require('minthril');
const { component } = require('../../component');
const { CostEstimate, formatUsd } = require('../../components/cost-estimate');
const { SiteNavigation } = require('../../components/site-navigation');
const { bytes } = require('../../components/usage-totals');

function duration(milliseconds) {
  if (!milliseconds) return '0 ms';
  if (milliseconds < 1000) return `${milliseconds.toLocaleString()} ms`;
  return `${(milliseconds / 1000).toFixed(1)} seconds`;
}

function usageWithOverage(total, overage, format) {
  return `${format(total)} (${format(overage)} over allowance)`;
}

const CostPage = component(() => ({
  view: ({ attrs: { site, stats, backHref, overviewHref, trafficHref, routesHref, costHref, settingsHref } }) => m('section.panel.site-detail.cost-page', [
    m(SiteNavigation, {
      breadcrumbs: [
        { label: backHref.startsWith('/admin') ? 'Admin' : 'Sites', href: backHref },
        { label: site.name, href: overviewHref },
        { label: 'Cost' }
      ],
      overviewHref,
      trafficHref,
      routesHref,
      costHref,
      settingsHref,
      current: 'cost'
    }),
    m('h2', `${site.name} cost`),
      m('p.cost-page__origin', site.origin),
    stats?.estimatedSpend ? [
        m(CostEstimate, { estimate: stats.estimatedSpend }),
        m('section.cost-page__breakdown', [
          m('h3', 'Customer usage breakdown'),
          m('p.cost-page__intro', 'This estimate uses the same request, data, and worker-time prices as Billing.'),
          m('dl.cost-page__totals', [
            m('div', m('dt', 'Connected-domain requests'), m('dd', usageWithOverage(
              stats.estimatedSpend.usage.billableProxiedRequests,
              stats.estimatedSpend.units.billableProxiedRequests,
              value => value.toLocaleString()
            ))),
            m('div', m('dt', 'Connected-domain data'), m('dd', usageWithOverage(
              bytes(stats.estimatedSpend.usage.billableResponseBodyBytes),
              bytes(stats.estimatedSpend.units.billableResponseBodyGiB * (1024 ** 3)),
              value => value
            ))),
            m('div', m('dt', 'Rendering and validation CPU'), m('dd', usageWithOverage(
              stats.estimatedSpend.usage.renderDurationMs + stats.estimatedSpend.usage.validationDurationMs,
              stats.estimatedSpend.units.workerDurationSeconds * 1000,
              duration
            )))
          ]),
          stats.estimatedSpend.billingTestEnabled && stats.estimatedSpend.billingMode === 'paid' && stats.estimatedSpend.lineItems?.length ? m('ul', stats.estimatedSpend.lineItems.map(item =>
            m('li', `${item.description}: ${formatUsd(item.amountMinor / 100, stats.estimatedSpend.currency)}`)
          )) : stats.estimatedSpend.billingMode === 'free' && stats.estimatedSpend.overageAmountUsd > 0
            ? m('p.muted', 'Usage is over the free allowance. Enable paid billing to make this usage chargeable.')
            : m('p.muted', stats.estimatedSpend.billingMode === 'comped'
              ? 'This account is comped; usage over the allowance is not charged.'
              : 'No chargeable usage after the included allowance.'),
          m('h3', 'Monthly usage'),
          m('p.cost-page__intro', 'Historical usage for this site. Final billing is calculated across your account.'),
          m('div.cost-page__monthly-table-wrap',
            m('table.cost-page__monthly-table', [
              m('thead', m('tr', [
                m('th', 'Month'),
                m('th', 'Requests'),
                m('th', 'Data'),
                m('th', 'CPU time'),
                m('th', 'Estimate')
              ])),
              m('tbody', (stats.estimatedSpend.monthlyUsage || []).map(month => m('tr', [
                m('th', month.month),
                m('td', month.usage.billableProxiedRequests),
                m('td', bytes(month.usage.billableResponseBodyBytes)),
                m('td', duration(
                  month.usage.renderDurationMs + month.usage.validationDurationMs
                )),
                m('td', formatUsd(month.amountUsd, month.currency))
              ])))
            ])
          )
        ]),
        m('p.muted.cost-page__note', 'Estimated from this site’s current-period usage. Your final bill is calculated across your account and includes the shared free allowance.')
    ] : m('p.muted', 'Calculating cost…')
  ])
}));

module.exports = { CostPage };
